import { forwardRef, MouseEventHandler } from 'react';

import * as S from './Toast.style';

interface IProps {
	children: React.ReactNode;
}

interface IButtonProps extends IProps {
	onClick?: MouseEventHandler<HTMLDivElement>;
}

const Container = forwardRef(
	({ children }: IProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.Container ref={ref}>{children}</S.Container>
	),
);
Container.displayName = 'Container';

const TextContainer = forwardRef(
	({ children }: IProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.TextContainer ref={ref}>{children}</S.TextContainer>
	),
);
TextContainer.displayName = 'TextContainer';

const Message = forwardRef(
	({ children }: IProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.Message type="body-large" ref={ref} color="white-primary" noOfLine={2}>
			{children}
		</S.Message>
	),
);
Message.displayName = 'Message';

const Button = forwardRef(
	(
		{ children, onClick }: IButtonProps,
		ref: React.ComponentPropsWithRef<React.ElementType>['ref'],
	) => (
		<S.Button ref={ref} onClick={onClick}>
			<span>{children}</span>
		</S.Button>
	),
);
Button.displayName = 'Button';

export { Container, TextContainer, Message, Button };
